export const styles = {
    headerBox: (isMobile, theme) => ({
        p: isMobile ? 1.5 : 2,
        background: theme.palette.background.header,
        position: 'relative',
        pt: isMobile ? 'calc(env(safe-area-inset-top) + 8px)' : 2,
        color: theme.palette.text.header
    }),
    backgroundPattern: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.05,
        backgroundImage: 'radial-gradient(circle at 20px 20px, rgba(255,255,255,0.8) 2px, transparent 0)',
        backgroundSize: '40px 40px'
    },
    contentBox: (isMobile) => ({
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        position: 'relative',
        pt: isMobile ? 0.5 : 0
    }),
    avatar: (isMobile) => ({
        width: isMobile ? 40 : 44,
        height: isMobile ? 40 : 44,
        bgcolor: 'rgba(255,255,255,0.1)',
        backdropFilter: 'blur(5px)',
        border: '1px solid rgba(255,255,255,0.2)'
    }),
    walletIcon: (isMobile, theme) => ({
        color: theme.palette.text.header,
        fontSize: isMobile ? 20 : 24
    }),
    title: (theme) => ({
        color: theme.palette.text.header,
        fontWeight: 700,
        mb: 0.5
    }),
    subtitle: (theme) => ({
        color: theme.palette.text.header,
        opacity: 0.7
    }),
    closeButton: (isMobile, theme) => ({
        position: 'absolute',
        right: 0,
        top: isMobile ? 0 : 0,
        color: theme.palette.text.header,
        opacity: 0.7,
        '&:hover': { 
            bgcolor: 'rgba(255,255,255,0.1)',
            opacity: 1
        }
    })
};
